import React, { useState } from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../head-container';
import { getImageFromS3 } from '../../../imageService';
import classNames from 'classnames';
import global from '../../index.module.scss';

export const tobaccoMythsChallengeList = [
  {
    id: '1',
    title:
      'Для виробництва якісного тютюну використовують листки лише з верхівок рослини.',
    answerTitle:
      'Насправді для виробництва якісного тютюну використовують листки з різних частин рослини.',
    image: getImageFromS3('/images/tobacco-myths-challenge/1.png'),
    isCorrect: false
  },
  {
    id: '2',
    title:
      'Сучасний тютюн містить менше нікотину завдяки спеціальним методам обробки.',
    answerTitle:
      'Так. Деякі сучасні методи обробки дозволяють зменшити вміст нікотину. Наприклад, за допомогою селекції сортів або спеціальної промивки листя.',
    image: getImageFromS3('/images/tobacco-myths-challenge/2.png'),
    isCorrect: true
  },
  {
    id: '3',
    title: 'Хороший тютюн вирощують тільки у тропічних кліматичних умовах.',
    answerTitle:
      'Тютюн вирощують у багатьох кліматичних зонах.\n' +
      'Наприклад, відомі сорти вирощують у США, Туреччині, Італії та навіть Україні.',
    image: getImageFromS3('/images/tobacco-myths-challenge/3.png'),
    isCorrect: false
  },
  {
    id: '4',
    title: 'Тютюнові листки потрібно зберігати при температурі 0–5°C.',
    answerTitle:
      'Це теж міф. Тютюнові листки зберігають у добре провітрюваних, сухих приміщеннях при контрольованій вологості. Але температура 0–5°C їм не потрібна.',
    image: getImageFromS3('/images/tobacco-myths-challenge/4.png'),
    isCorrect: false
  },
  {
    id: '5',
    title: 'Тютюн колись використовували як валюту.',
    answerTitle:
      'У колоніальній Америці листя тютюну вважалось платіжним засобом. Його використовували, щоб розрахуватись за товари. Також ним могли сплатити податки.',
    image: getImageFromS3('/images/tobacco-myths-challenge/5.png'),
    isCorrect: true
  }
];

export const tobaccoMythsResultList = [
  {
    resultId: '1',
    title: 'Не хвилюйся',
    text:
      'Навіть професійні фактчекери помиляються.\n' +
      'Спробуй ще раз, щоб закріпити нові знання.',
    image: getImageFromS3('images/tobacco-myths-challenge/result1.png')
  },
  {
    resultId: '2',
    title: 'Непогано!',
    text:
      'Тобі вдалось розгадати майже всі факти.\n' +
      'Ще трішки — і знатимеш про тютюн усе.',
    image: getImageFromS3('images/tobacco-myths-challenge/result2.png')
  },
  {
    resultId: '3',
    title: 'Вітаємо!',
    text: 'Тобі вдалось виявити всі неправдиві факти. Ти справжній фактчекер!',
    image: getImageFromS3('images/tobacco-myths-challenge/result3.png')
  }
];

const TobaccoMythsChallenge = ({
  setScreenNumber,
  backgroundImage,
  setScreenNumberAfterResult
}) => {
  const [challengeStep, setChallengeStep] = useState(0);
  const [selectQuestion, setSelectQuestion] = useState(
    tobaccoMythsChallengeList[0]
  );
  const [challengeResult, setChallengeResult] = useState([]);
  const [isShowCorrectResult, setIsShowCorrectResult] = useState(false);
  const [isResultView, setIsResultView] = useState(false);
  const [isWelcomeScreen, setIsWelcomeScreen] = useState(true);
  const [result, setResult] = useState(null);

  const handleSelect = (answer, checkedValue) => {
    const isExistAnswer = challengeResult.find(
      (item) => item.questionId === selectQuestion.id
    );
    if (isExistAnswer) {
      const updatedResultList = challengeResult.filter(
        (item) => item.questionId !== selectQuestion.id
      );
      setChallengeResult([
        ...updatedResultList,
        {
          questionId: selectQuestion.id,
          answerId: answer.id,
          isCorrect: answer?.isCorrect === checkedValue
        }
      ]);
    } else {
      setChallengeResult([
        ...challengeResult,
        {
          questionId: selectQuestion.id,
          answerId: answer.id,
          isCorrect: answer?.isCorrect === checkedValue
        }
      ]);
    }
    setIsShowCorrectResult(true);
  };

  const handleViewResult = () => {
    let correctAnswersCount = challengeResult?.filter(
      (item) => item?.isCorrect
    )?.length;
    const correctAnswerIndex =
      correctAnswersCount <= 2
        ? 0
        : correctAnswersCount >= 3 && correctAnswersCount < 5
        ? 1
        : 2;
    setResult(tobaccoMythsResultList[correctAnswerIndex]);
    setIsResultView(true);
  };

  return (
    <div
      className={styles.trueFalseSohoChallenge}
      style={{ backgroundImage: backgroundImage }}
    >
      <div style={{ padding: '0 30px' }}>
        <HeadContainer setScreenNumber={setScreenNumber} />
      </div>
      {isWelcomeScreen && !isResultView && (
        <div className={styles.welcomeContainer}>
          <div className={styles.headContainer}>
            <img
              src={getImageFromS3(
                'images/tobacco-myths-challenge/welcome-image.png'
              )}
              alt="welcome-icon"
            />
          </div>
          <p className={styles.description}>
            Тютюн має багатовікову історію, тому з ним пов’язано чимало цікавих
            фактів.<br></br>
            <br></br>
            Але чи зможеш ти відрізнити правду від вигадки?
          </p>
          <button onClick={() => setIsWelcomeScreen(false)}>Починаймо!</button>
        </div>
      )}
      {!isResultView && !result && !isWelcomeScreen && (
        <>
          <div className={styles.stepToolbar}>
            {tobaccoMythsChallengeList.map((item, index) => (
              <div
                className={classNames(
                  styles.stepItem,
                  index === challengeStep && styles.activeStepItem
                )}
              />
            ))}
          </div>
          {selectQuestion && (
            <div className={styles.questionItem}>
              <span className={styles.titleQuestion}>
                {isShowCorrectResult && (
                  <div className={styles.answerTitleContainer}>
                    {selectQuestion?.isCorrect ? 'ПРАВДА' : 'МІФ'}
                  </div>
                )}
                {isShowCorrectResult
                  ? selectQuestion?.answerTitle
                  : selectQuestion.title}
              </span>
              <div className={styles.imageList}>
                <div id={selectQuestion.id} className={styles.imageContainer}>
                  <img
                    src={selectQuestion.image}
                    alt={selectQuestion.id}
                    className={styles.imageItem}
                  />
                </div>
              </div>
            </div>
          )}
          <div className={styles.buttonContainer}>
            {!isShowCorrectResult ? (
              <>
                <button
                  className={global.menuButton}
                  onClick={() => handleSelect(selectQuestion, true)}
                >
                  Правда
                </button>
                <button
                  className={global.errorButton}
                  onClick={() => handleSelect(selectQuestion, false)}
                >
                  Міф
                </button>
              </>
            ) : (
              <button
                className={global.menuButton}
                onClick={() => {
                  if (tobaccoMythsChallengeList.length > challengeStep + 1) {
                    setSelectQuestion(
                      tobaccoMythsChallengeList[challengeStep + 1]
                    );
                    setChallengeStep(challengeStep + 1);
                    setIsShowCorrectResult(false);
                  } else {
                    handleViewResult();
                    setIsShowCorrectResult(false);
                  }
                }}
              >
                Далі
              </button>
            )}
          </div>
        </>
      )}
      {isResultView && result && (
        <div className={styles.resultContainer}>
          <img src={result?.image} alt="result" />
          <div className={styles.description}>
            <p className={styles.resultTitle}>{result.title}</p>
            <p className={styles.resultDescription}>{result.text}</p>
          </div>
          <button
            className={global.menuButton}
            onClick={setScreenNumberAfterResult}
          >
            Далі
          </button>
        </div>
      )}
    </div>
  );
};

export default TobaccoMythsChallenge;
